import { Box, styled } from '@mui/material';

const StyledBox = styled(Box)(() => ({
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  alignItems: 'center',
  display: 'flex',
  gap: 8,
  '& > .div': {
    flexShrink: 0,
  },
}));

export default StyledBox;
